import assets from "app/assets";
import config from "config";
import gsap from "gsap";
import { Container, NineSlicePlane, TextStyle, Text, DEG_TO_RAD, Sprite, Texture, BaseTexture } from "pixi.js";
import tools, { isMobileOS } from "tools";
let WIDTH = window.innerWidth * 0.255;
const HEIGHT = 110;
export default class boosterPopin extends Container {
  constructor() {
    super();
    if (isMobileOS()) {
      WIDTH = Math.min(window.innerWidth * 1.2, window.innerHeight * 1.2);
      //ipad
      if (window.innerWidth / window.innerHeight > 0.74) {
        WIDTH = Math.min(window.innerWidth, window.innerHeight);
      }
    }
    tools.autobind(this);
    this.maxScale = 1;
    this._init();
    this._initEvents();
  }
  _init() {
    if (WIDTH < 500) {
      this.maxScale = 0.8;
    }
    ;
    this.bg = new NineSlicePlane(assets.textures.popupBoosterBg.texture, 34, 36, 34, 51);
    this.bg.width = WIDTH;
    this.bg.height = HEIGHT;
    this.bg.x = -WIDTH / 2;
    this.bg.y = -HEIGHT / 2;
    this.addChild(this.bg);
    this.close = assets.textures.popupBoosterClose;
    this.close.anchor.set(.5, 0.5);
    // this.close.scale.set(.5);
    this.close.position.set(WIDTH * 0.47, -HEIGHT / 2);
    if (WIDTH == 500) {
      this.close.position.set(WIDTH * 0.5, -HEIGHT / 2);
    }
    this.addChild(this.close);
    const titleStyle = new TextStyle({
      fontFamily: 'Anja Eliane accent',
      fontSize: 20,
      fill: '#10b7fe',
      stroke: '#0b2944',
      strokeThickness: 2,
      dropShadow: true,
      dropShadowAlpha: 1,
      dropShadowAngle: DEG_TO_RAD * 90,
      dropShadowBlur: 1,
      dropShadowColor: '0x0b2944',
      dropShadowDistance: 2,
      lineHeight: 29,
      align: "center"
    });

    //text must be uppercase
    this.title = new Text(assets.local.boosterPopinTitle.toUpperCase(), titleStyle);
    this.title.anchor.set(0.5, 0.5);
    this.title.x = this.bg.x + this.bg.width * 0.55;
    this.title.y = this.bg.y + this.bg.height * 0.27;
    this.addChild(this.title);
    this.textStyle = new TextStyle({
      fontFamily: 'Anja Eliane accent',
      fontSize: 20,
      fill: '#ffffff',
      stroke: '#0b2944',
      strokeThickness: 2,
      dropShadow: true,
      dropShadowAlpha: 1,
      dropShadowAngle: DEG_TO_RAD * 90,
      dropShadowBlur: 1,
      dropShadowColor: '0x0b2944',
      dropShadowDistance: 1,
      wordWrap: true,
      wordWrapWidth: 340,
      align: 'center'
    });
    this.text = new Text("", this.textStyle);
    this.text.anchor.set(0.5, 0.5);
    this.text.x = this.bg.x + this.bg.width * 0.55;
    this.text.y = this.bg.y + this.bg.height * 0.63;
    this.rays = assets.textures.rays;
    this.rays.anchor.set(.5);
    this.rays.scale.set(.4);
    this.rays.position.set(-180, -10);
    this.addChild(this.rays);
    this.pic = new Sprite(new Texture(new BaseTexture()));
    this.pic.anchor.set(.5);
    this.pic.scale.set(.65);
    this.pic.position.set(-180, -10);
    this.addChild(this.pic);
    this.addChild(this.text);
    this.movesText = new Text("Moves", this.textStyle);
    this.movesText.anchor.x = .5;
    this.movesText.visible = false;
    this.addChild(this.movesText);
    this.scale.set(0);
    this.visible = false;
    this._isDown = false;
  }
  _initEvents() {
    this.interactive = true;
    this.close.interactive = true;
    this.close.buttonMode = true;
    this.close.on('pointerdown', this._onDown);
    this.close.on('pointerup', this._onUp);
    this.close.on('pointerupoutside', this._onOut);
  }
  _onDown() {
    if (this._isDown) {
      return;
    }
    this._isDown = true;
    this.tween = gsap.to(this.close.scale, {
      duration: .2,
      x: .93 * this.maxScale,
      y: .93 * this.maxScale
    });
  }
  _onUp() {
    if (!this._isDown) {
      return;
    }
    this._isDown = false;
    this.tween && this.tween.kill();
    this.tween = gsap.to(this.close.scale, {
      duration: .2,
      x: 1 * this.maxScale,
      y: 1 * this.maxScale
    });
    this.hide();
  }
  _onOut() {
    this._isDown = false;
    this.tween && this.tween.kill();
    this.tween = gsap.to(this.close.scale, {
      duration: .2,
      x: 1 * this.maxScale,
      y: 1 * this.maxScale
    });
  }
  show(pic, text, width = 0, height = 0, title = true, callback, fromBooster = false, picScale = .65, onlyText = false) {
    this.closeCallback = callback;
    if (width) {
      //  this.y = config.view.y / 2;
      this.bg.height = height;
      this.bg.y = -height / 2;
      this.bg.width = width;
      this.bg.x = -width / 2;
      this.close.position.set(width * 0.47, -height / 2);
      if (WIDTH == 500) {
        this.close.position.set(width * 0.5, -height / 2);
      }
      this.pic.position.x = -30;
      this.rays.x = this.pic.position.x;
      this.rays.scale.set(.5);
      this.rayTween && this.rayTween.kill();
      this.rayTween = gsap.to(this.rays, {
        yoyo: true,
        repeat: -1,
        duration: 2,
        rotation: DEG_TO_RAD * 90,
        ease: "none"
      });
      //this.text.x = 20;
      this.textStyle.fontSize = 50;
    } else {
      // this.y = 875;
      this.bg.width = WIDTH;
      this.bg.x = -WIDTH / 2;
      this.bg.height = HEIGHT;
      this.bg.y = -HEIGHT / 2;
      this.close.position.set(WIDTH * 0.47, -HEIGHT / 2);
      if (WIDTH == 500) {
        this.close.position.set(WIDTH * 0.5, -HEIGHT / 2);
      }
      this.pic.position.x = -180;
      //  this.text.x = -120;
      this.pic.x = -180;
      this.rays.x = -180;
      this.rays.scale.set(.4);
      this.rayTween && this.rayTween.kill();
      this.textStyle.fontSize = 21;
    }
    this.title.visible = title;
    this.pic.scale.set(picScale);
    this.scale.set(.2);
    this.visible = true;
    gsap.to(this.scale, {
      duration: .4,
      x: 1 * this.maxScale,
      y: 1 * this.maxScale,
      ease: "back.out(1)"
    });
    this.close.scale.set(0);
    this.tween = gsap.to(this.close.scale, {
      duration: .4,
      delay: .4,
      x: 1 * this.maxScale,
      y: 1 * this.maxScale,
      ease: "back.out(2)"
    });

    // this.text.y = -5;
    this.text.scale.set(1);
    this.text.text = text.toUpperCase();
    if (pic) {
      this.pic.texture = pic;
      this.pic.visible = true;
      this.rays.visible = true;
    } else {
      this.pic.visible = false;
      this.rays.visible = false;
      // this.text.x = -this.text.width / 2 - 20;
      // this.text.y = -70;
      this.text.scale.set(1.4);
    }
    if (onlyText) {
      this.movesText.visible = true;
    } else {
      this.movesText.visible = false;
    }
    if (!fromBooster) {
      this.autoHideTimer && this.autoHideTimer.kill();
      this.autoHideTimer = gsap.delayedCall(3, this.hide);
    }
  }
  hide(cancel = true) {
    this.autoHideTimer && this.autoHideTimer.kill();
    config.touchAccess = true;
    if (cancel) {
      config.bombBoosterReady = false;
      config.roketBoosterReady = false;
      config.swapBoosterReady = false;
    }
    gsap.to(this.scale, {
      duration: .3,
      x: 0,
      y: 0,
      onComplete: () => {
        this.visible = false;
      }
    });
    this.closeCallback && this.closeCallback();
    this.closeCallback = null;
  }
}
